export const Menus = {
    DASHBOARD: "Dashboard",
    ATTENDANCE: "Attendance",
    BRANCH: "Branch",
    Location: "Location",
    DEPARTMENT: "Department",
    DESIGNATION: "Designation",
    SHIFT: "Shift",
    EMPLOYEE: "Employee",
    THUMB_APPLICATION: "Thumb Application",
    HOLIDAY_APPLICATION: "Holiday Application",
    LEAVE_APPLICATION: "Leave Application",
    OVERTIME_APPLICATION: "Overtime Application",
    FUEL_ALW_APPLICATION : "Fuel Alw Application",
    RESIGN_APPLICATION: "Resign Application",
    ATTENDANCE_REPORT: "Attendance Report",
    COMPANY_MASTER: "Company Master",
    ROLE_MASTER: "Role Master",
    USER_MASTER: "User Master",
    BANK_MASTER: "Bank Master",
    HOLIDAY_MASTER: "Holiday Master",
    LEAVE_MASTER: "Leave Master",
    PROFESSIONAL_TAX_MASTER: "Professtional Tax Master",
    DOCUMENT_TYPE_MASTER: "Document Type Master",
    PAYMENT_TYPE_MASTER: "Payment Type Master",
    MENU_ACCESS_UTILITY: "Menu Access Utility",
    EXTRAPAY_APPLICATION: "Extrapay Application",
    CLARIFICATION_APPLICATION: "Clarification Application",
    INOUT_REPORT: "Inout Report",
    LATE_EARLY_REPORT: "Late Early Report",
    MISSING_THUMB_REPORT: "Missing Thumb Report",
    SALARY_REPORT: "Salary Report",
    TDS_REPORT: "TDS Report",
    CALCULATE_MONTH_SALARY: "Calculate Month Salary",
    CALCULATE_FINAL_ATTENDACE: "Calculate Final Attendance",
    EMPLOYEE_INCREMENT: "Employee Increment",
    FUEL_ALW_MASTER:"Fuel Alw Master",    
    ORGANIZATION_CHART : "ORG Chart",
    PROJECT_MASTER : "Project Master",
    EMPLOYEE_SHIFT_ASSIGN: "Employee Shift Assign",
    INSTRUCTION_MASTER: "Instruction Master",
    REQUEST_MODULE: "Request Application",
    MONTHLY_SUMMARY_REPORT: "Monthly Summary Report",
    DAILY_DETAIL_REPORT: "Daily Detail Report",
    GENERATE_LETTER: "Generate Letter",
    DEVICE_SETTING: "Device Setting",
    PERMANENT_EMPLOYEE: "Permanent Employee",
    WORK_FROM_HOME: "Work From Home",
    SALARY_SUMMARY_REPORT: "Salary Summary Report",
    EMAIl_SETTING: "Email Setting",
    EMAIL_TEMPLATE: "Email Template",
    INCREMENT_REPORT: "Increment Report",
    SHORT_HOUR_REPORT: "Short Hour Report"  ,
    CLARIFICATION_REPORT: "Clarification Report", 
    INCOME_TAX_SLAB: "Income Tax Slab",
    INVESTMENT_SCHEMA_MASTER: "Investment Schema Master",
    INVESTMENT_DETAIL: "Investment Detail",
    FORM_16_REPORT: "Form 16 Report",
    YEARLY_TRANSFER: "Yearly Transfer",
    EMPLOYEE_ITMETHOD: "Employee ITMethod",
    EMPLOYEE_ADDITIONAL_SALARY: "Employee Additional Salary",
    RULE_MASTER: "Rule Master",
    GENERAL_SETTING: "General Setting",
    WEEKEND_SETTING: "Weekend Setting",
    SHIFT_GROUP: "Shift Group",
    PF_MASTER:'PF Master',
    ESIC_MASTER:'ESIC Master',
    LWF_MASTER:'LWF Master',
    ALLOWANCE_MASTER: 'Allowance Master',
    SALARY_STRUCTURE_MASTER:'Salary Structure Master',
    SALARY_STRUCTURE_DETAIL:'Salary Structure Detail',
    BONUS_DETAILS:'Bonus Details',
    DTA_MASTER: 'DTA Master',
    COMPENSATION_MASTER: 'Compensation Master',
    COMPENSATION_APPLICATION: 'Compensation Application',
    LEAVE_ENCASHMENT: 'Leave Encashment',
    LEAVE_BALANCE : 'Leave Balance Report',
    ADVANCE_PAID: 'Advance Paid',
    CHECK_LIST_MASTER:'Check List Master',
    EMPLOYEE_CHECKLIST:'Employee Checklist',
    FUEL_ALW_REPORT:'Fuel Alw Report',
    DTA_REPORT:'DTA Report',
    CUSTOM_EMAIL: 'Custom Email',
    EDUCATION:'Education Master',
    DOCUMENT_VAULT:'Document Vault Master',
    EMPLOYEE_TRAINING_APPLICATION:'Employee Training Application',
    ASSET_MASTER: 'Asset Master',
    ASSET_MANAGEMENT:'Asset Management',
    ACCOUNT_MASTER: 'Account Master',
    EXPENSE_CATEGORY_MASTER: 'Expense Category Master',
    PROJECT_INCOME: 'Project Income',
    EXPENSE_ENTRY: 'Expense Entry',
    EXPENSE_DASHBOARD: 'Expense Dashboard',
    INTERN_MASTER: 'Intern Master',
    INTERN_FEE: 'Intern Fee'
}
